/**
 * Maps the `status` single-letter code from SeparatorMessage to a human-readable
 * label and a Lucide React icon component.
 *
 * Unknown codes fall back to displaying the raw letter (defensive default —
 * prevents blank display if the server adds new codes in the future).
 *
 * Usage in side panel:
 * ```typescript
 * const { label, Icon } = STATUS_MAP[message.status] ?? { label: message.status, Icon: null };
 * // render: {Icon && <Icon size={14} />} {label}
 * ```
 */

import { Zap, TrendingUp, Scissors, TrendingDown, Package } from 'lucide-react';
import type { FC } from 'react';
import type { LucideProps } from 'lucide-react';

export interface StatusEntry {
  label: string;
  Icon: FC<LucideProps> | null;
}

export const STATUS_MAP: Record<string, StatusEntry> = {
  s: { label: 'Démarrage',    Icon: Zap          },
  m: { label: 'Montée',       Icon: TrendingUp   },
  c: { label: 'Séparation',   Icon: Scissors     },
  d: { label: 'Descente',     Icon: TrendingDown },
  r: { label: 'Récupération', Icon: Package      },
};
